export default __webpack_public_path__ + "static/media/defaultMeeting.40bedbe2.svg";